const basePath = 'marketing'
export const CRM_ROUTER_MKT = {
	root: `${basePath}`,
	short_link: `${basePath}/short-links`
}
